<div mat-dialog-title i18n>Обработка углов</div>
<mat-dialog-content class="flex flex-row space-x-4 h-96">
  <csl-countertop-angle-settings
    class="basis-1/2"
    [countertop]="_countertop"
    [angleNumber]="data.angleNumber"
    [angleProcessingAvailability]="data.angleProcessingAvailability"
    [outlineOptions]="data.outlineOptions">
  </csl-countertop-angle-settings>

  <div class="flex-auto">
    <img src="{{ getSchemaLink() }}" />
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="accent" (click)="save(_countertop)" data-testid="saveAngleSetting" i18n
    >Сохранить</button
  >
  <button mat-button [mat-dialog-close] cdkFocusInitial i18n>Отмена</button>
</mat-dialog-actions>
